// extracted by mini-css-extract-plugin
export default {"topsection":"Results_topsection__KqDA1","name":"Results_name__Ad9Pr","rtable":"Results_rtable__xOh16","rth":"Results_rth__4wzlJ","rtd":"Results_rtd__1DZEt"};